$(() => {
    class BModalFormN {
        constructor() {
            this.triggers = document.querySelectorAll('a[href^="#popup-"]');
            this.addHandlers();
        }

        addHandlers() {
            this.triggers.forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    const href = e.target.getAttribute('href');
                    const idModal = href.split('-')[1];
                    const modal = document.querySelector(`#${idModal}`);

                    if (modal) {
                        this.openModalForm(modal);
                    }
                })
            })
        }

        openModalForm(modal) {
            $.fancybox.open(modal, {
                width: '100%'
            });
        }
    }

    new BModalFormN();
});

/*

<div class="form-standart js-ajax is-ver is-e1 js-ajax is-hor is-e3 is-smi is-with-gates self-init bem">
    <div class="form-standart__inner-content">

						<div class="form-standart__title">
									Предложить сервис							</div>
				<form name="service_offer" action="/ajax/popup_form.php" method="POST" enctype="multipart/form-data" id="form_rand"><input type="hidden" name="sessid" id="sessid" value="bbc680f0b4f43db8ae0d4db988dabef1" /><input type="hidden" name="WEB_FORM_ID" value="29" />		<input type="hidden" name="block_name" value="form-standart" />
		<input type="hidden" name="confirm" value="1" />
		<input type="hidden" name="ajax" value="1" />
		<input type="hidden" name="action" value="formsubmit" />

								<div class="form-standart__fields-list">



									<div class="form-standart__field
                         "
					     data-necessary="data-necessary"					>
						<div class="form-standart__label">
							Имя
													</div>

						<div class="form-standart__item">
							<div class="form-standart__inputs">
																	<input type="text" class="inputtext" name="form_text_15959" value="" data-fieldname="NAME"  autocomplete="on" />															</div>
							<div class="form-standart__message">
								<div class="form-standart__none">Вы не заполнили имя</div>
								<div class="form-standart__error">Поле на заполнено</div>
							</div>
						</div>
					</div>


									<div class="form-standart__field
                         "
					     data-necessary="data-necessary"					>
						<div class="form-standart__label">
							Телефон
													</div>

						<div class="form-standart__item">
							<div class="form-standart__inputs">
																	<input type="text" class="inputtext" name="form_text_15962" value="" data-fieldname="PHONE" data-mask="phone" autocomplete="on" />															</div>
							<div class="form-standart__message">
								<div class="form-standart__none">Вы не заполнили телефон</div>
								<div class="form-standart__error">Поле на заполнено</div>
							</div>
						</div>
					</div>


									<div class="form-standart__field
                         "
					     data-necessary="data-necessary"					>
						<div class="form-standart__label">
							Электронный адрес
													</div>

						<div class="form-standart__item">
							<div class="form-standart__inputs">
																	<input type="text" class="inputtext" name="form_email_15965" value="" data-fieldname="EMAIL"  data-type="email" autocomplete="on" />															</div>
							<div class="form-standart__message">
								<div class="form-standart__none">Вы не заполнили электронную почту</div>
								<div class="form-standart__error">Поле на заполнено</div>
							</div>
						</div>
					</div>


									<div class="form-standart__field
                         "
					     data-necessary="data-necessary"					>
						<div class="form-standart__label">
							Какой сервис вы бы хотели?
													</div>

						<div class="form-standart__item">
							<div class="form-standart__inputs">
																	<input type="text" class="inputtext" name="form_text_15968" value="" data-fieldname="SERVICE"  autocomplete="on" />															</div>
							<div class="form-standart__message">
								<div class="form-standart__none">Заполнение поля обязательно</div>
								<div class="form-standart__error">Поле на заполнено</div>
							</div>
						</div>
					</div>






			<div class="form-standart__field is-field-btn">
				<div class="form-standart__item">
					<div class="form-standart__common-error-placeholder"></div>
				</div>
			</div>

			<div class="form-standart__field is-field-btn">
				<div class="form-standart__label is-empty">&nbsp;</div>
				<div class="form-standart__item">
					<div class="form-standart__inputs">
						<input 							type="submit"
							name="web_form_submit"
							value="Отправить"
							class="button-primary" />
					</div>
				</div>
			</div>


		</div>
		</form>

    <div class="success-message-modal">
        <div class="success-message-modal__caption">Спасибо!</div>
        <div class="success-message-modal__text">Спасибо, ваша заявка принята</div>
    </div>

			<script>
		$(function () {
			$("#form_rand").initWebForm("form-standart", {"WP_FORM_ID":"form_rand","WP_SUCCESS_MODE":"S4","WP_DEFAULT_SUCCESS_MESSAGE":"<div class='b-message'><div class='b-message__content'><div class='b-message__title'>\u0412\u0430\u0448\u0430 \u0437\u0430\u044f\u0432\u043a\u0430 \u043d\u0430 \u0441\u0435\u0440\u0432\u0438\u0441 \u043f\u0440\u0438\u043d\u044f\u0442\u0430<\/div><div class='b-message__text'><p>\u0412\u0430\u0448\u0435 \u043f\u0440\u0435\u0434\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u043f\u043e\u043b\u0443\u0447\u0435\u043d\u043e \u0438 \u0437\u0430\u0431\u043e\u0442\u043b\u0438\u0432\u043e \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e \u0432 \u043d\u0430\u0448\u0435\u0439 \u0441\u0438\u0441\u0442\u0435\u043c\u0435. \u0421\u043f\u0430\u0441\u0438\u0431\u043e \u0437\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043d\u0430\u0448\u0435\u043c \u043f\u0440\u043e\u0435\u043a\u0442\u0435 \u0438 \u0438\u043d\u0442\u0435\u0440\u0435\u0441 \u043a \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0435 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u043d\u0438\u043c\u0430\u0442\u0435\u043b\u044c\u0441\u0442\u0432\u0430 \u0432 \u0420\u043e\u0441\u0441\u0438\u0438<\/p><p>\u0412\u044b \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u0440\u0435\u0434\u043b\u043e\u0436\u0438\u0442\u044c \u043d\u0435\u043e\u0433\u0440\u0430\u043d\u0438\u0447\u0435\u043d\u043d\u043e\u0435 \u043a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u0441\u0435\u0440\u0432\u0438\u0441\u043e\u0432<\/p><p>\u0416\u0435\u043b\u0430\u0435\u043c \u0443\u0434\u0430\u0447\u0438!<\/p><\/div><\/div><\/div>"});
		});
			</script>
    </div>
</div>

 */
